<template>
	<div>
		<div class="files-list files-list--margin row justify-content-center">
			<div class="list col-12 col-md-4" v-for="(file, i) in currentFiles">
				<file-input :key="`files${i}`"
				:accept="accept"
				:uploadEndpoint="uploadEndpoint"
				:file="file"
				@uploaded="(uploadedFile, requestResponse) => onUploaded(uploadedFile, i, requestResponse)"
				@file-cleared="clearFile(i)"/>

				<div class="file text-center">
				<a v-if="currentFiles.length > 1" @click="removeFile(i)" title="Remover Arquivo" class="icon icon-minus-circle remove"> <span>Remover arquivo</span></a>
				</div>
			</div>
		</div>
		<div class="btns text-center">
			<button @click="addFile" class="btn btn-lg btn-link" style="" title="Adicionar mais arquivo">
				<span class="icon icon-plus-circle add-icon">
					<span>Adicionar mais arquivo</span>
				</span>
			</button>
		</div>
	</div>
</template>

<style lang="scss">
	.modal-body > div {
		overflow-x: initial !important;
	}
</style>


<style lang="scss" scoped>
  @import "../assets/styles/base/_base.scss";
	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";
	
	@include mob {
		.list {
			width: 100%;
		}
	}

	@include xs {
		.list {
			width: 100%;
			margin-bottom: 2.5rem;
		}
	}

	.files-list {
		/*display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;

		@include xs {
				margin-bottom: 10px;
				flex-direction: column;
				align-items: flex-start;
				justify-content: flex-start;
			} */
		}

		.add-icon {
			font-size: 50px;
		}

		.file {
			a {
				color: red;
				span {
					position: relative;
					color: #999;
					top: -2px;
					padding-left: 3px;
					font-family: $fontcontent;
					font-size: 12px;
				}

				&:hover {
					span {
						color: red;
					}
				}
			}
		}

		.btns {
			button {
				&[type='button'] {
				   background-color: none !important;
				}
				color: #41d3bd !important;
				border: 0px;
				text-decoration: none !important;
				span {
					@include font-size(35px);
					> span {
						padding-left: 10px;
						position: relative;
						top: -4px;
						font-family: $fontcontent;
						@include font-size(25px);
						color: #666;
					}
				}
			}
		}


	@include mob {
		.files-list--margin {
			padding:0px;
			margin-bottom: 1rem;
		}
		.file {
			width: 100%;
			a {
				span {
					top: -2px;
					padding-left: 3px;
					font-size: 12px;
				}
				&:hover {
					span {
						color: red;
					}
				}
			}
		}
		.btns {
			button {
				span {
					@include font-size(25px);
					> span {
						padding-left: 3px;
						position: relative;
						top: -4px;
						font-family: $fontcontent;
						@include font-size(18px);
						color: #666;
					}
				}
			}
		}
	}

	@include xs {
		.files-list--margin {
			padding:0px;
		}
		.file {
			width: 100%;
			a {
				span {
					top: -2px;
					padding-left: 3px;
					font-size: 12px;
				}
				&:hover {
					span {
						color: red;
					}
				}
			}
		}
		.btns {
			button {
				span {
					@include font-size(25px);
					> span {
						padding-left: 3px;
						position: relative;
						top: -4px;
						font-family: $fontcontent;
						@include font-size(18px);
						color: #666;
					}
				}
			}
		}
	}
</style>

<script>
  import FileInput from '@/components/FileInput'

  export default {
    components: { FileInput },
    props: {
      files: {required: true, type: Array},
      accept: {required: true, type: String},
      uploadEndpoint: {required: true, type: String},
    },
    computed: {
      currentFiles: function() { return this.files.length > 0 ? this.files : [null] }
    },
    methods: {
      addFile(e) {
		e.preventDefault();
        this.$emit('files-changed', this.currentFiles.concat(null))
      },
      removeFile(index) {
        this.$emit('files-changed', this.currentFiles.filter((file, i) => i != index))
      },
      clearFile(index) {
        const updatedFiles = Array.map(this.currentFiles, (file, i) => i != index ? file : null)
        this.$emit('files-changed', updatedFiles)
      },
      onUploaded(uploadedFile, index, response) {
        const updatedFiles = Array.map(this.currentFiles, (file, i) => i != index ? file : uploadedFile)
        this.$emit('files-changed', updatedFiles, {uploadResponse: response})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FilesInput.vue